import academic_transcript_icon from '../js/academic_transcript_icon.js'
import formatBytes from '../js/bytes_conversion.js'

var options = {
  valueNames: ['attachment_id','attachment_icon','file_name','byte_size','attachment_created_at',{ name: 'attachment_download_url', attr: 'href' },{ name: 'attachment_remove_id', attr: 'data-attachmentid' },{ name: 'attachment_remove_url', attr: 'href' },],
  item: '<li class="list-group-item px-0 academic_transcript_list_item"><div class="row align-items-center"><div class="col-auto"><div class="attachment_id invisible-element"></div><div class="avatar avatar-lg overflow-hidden"><span class="avatar-title rounded bg-white text-secondary attachment_icon"></span></div></div><div class="col ml-n2"><h4 class="card-title mb-1 file_name"></h4><p class="small text-muted mb-1 byte_size"></p><p class="small text-muted attachment_created_at"></p></div><div class="col-auto"><a class="btn btn-sm mr-2 btn-primary d-none d-md-inline-block attachment_download_url">Download</a><a data-behavior="delete" class="btn btn-outline-danger btn-sm attachment_remove_url attachment_remove_id" rel="nofollow" data-method="delete">Remove</a></div></div></li>'
};


if($(".academic_transcript_list_item").length > 0){
	window.academic_transcript_list = new List('uploaded_academic_transcripts', options);
}

function data_value(data){

	var data_value =  [{
	  attachment_id: data["academic_transcript"]["id"],
	  attachment_icon: academic_transcript_icon(data["academic_transcript"]["content_type"]),
	  file_name: data["academic_transcript"]["filename"],
	  byte_size: formatBytes(data["academic_transcript"]["byte_size"]),
	  attachment_created_at: "Uploaded on " + data["academic_transcript"]["created_at"],
	  attachment_download_url: data["attachment_download_url"],
	  attachment_remove_id: data["academic_transcript"]["id"],
	  attachment_remove_url: data["attachment_remove_url"]
	}];

	return data_value;
}


export function create_new_academic_transcript_list(data){
	var list_value = data_value(data);
	window.academic_transcript_list = new List('uploaded_academic_transcripts', options,list_value);
}

export function add_to_academic_transcript_list(data){
	var list_value = data_value(data);
	academic_transcript_list.add(list_value);
}
